<section class="valorations-shell" [class.valorations-shell--geomarker]="variant() === 'geomarker'">
  @if (variant() === 'geomarker') {
    <span class="fw-bold fs-5">{{ 'geomarker.reviews_title' | translate }}</span>
  } @else {
    <div class="col-12 text-center mb-3 p-0">
      <span class="fs-3 text-center">{{
        'geomarker.title_user_reviews_and_ratings' | translate
      }}</span>
    </div>
  }

  <div
    class="valorations-content"
    [class.valorations-content--geomarker]="variant() === 'geomarker'"
  >
    @if (variant() === 'geomarker') {
      <div class="rating-overview">
        <div class="rating-overview__score">
          <strong>{{ qualification() }}</strong>
          <app-rating
            [qualification]="qualification()"
            [disabled]="true"
            [showRatingNumber]="false"
            size="17px"
          />
          <span>{{ totalRatings() }} {{ 'rating_modal.ratings' | translate }}</span>
        </div>
        <div class="rating-overview__bars">
          @for (row of ratingRows(); track row.score) {
            <div class="rating-bar">
              <span>{{ row.score }}</span>
              <div><span [style.width.%]="row.percentage"></span></div>
              <small>{{ row.percentage }}%</small>
            </div>
          }
        </div>
      </div>
      <div class="valorations-divider"></div>
    }

    <div class="valorations-comments">
      <div class="reviews-heading">
        @if (totalValuations()) {
          <button type="button" class="btn-valuations" (click)="openValorationsModal()">
            {{ 'reviews_modal.view_all' | translate }}
            <i class="inm-icon-arrow-right" aria-hidden="true"></i>
          </button>
        }
      </div>

      @if (previewValorations().length) {
        <div class="valorations-list">
          @for (valoration of previewValorations(); track valoration.id) {
            <app-valoration-detail-item
              [valorationDetail]="valoration"
              (valuationsChange)="getValuations(undefined, true)"
            />
          }
        </div>
      } @else {
        <div class="notifications-content text-center empty px-3">
          <div class="d-flex flex-column align-items-center justify-content-center gap-2 mb-2">
            <span class="fw-bold">{{ 'this_site_not_have_califications' | translate }}</span>
            <img lazyLoad="img/icons/valoration_icon-empty.png" height="70" alt="" />
          </div>
          <p>{{ 'share_ur_experience' | translate }}</p>
        </div>
      }
    </div>

    <aside class="valorations-action">
      <app-valoration-card
        [variant]="variant() === 'geomarker' ? 'compact' : 'default'"
        [marker]="marker()"
        [city]="city()"
        [valuations]="totalValuations()"
        [hasQualification]="hasQualification()"
        [busy]="qualificationRequest()"
        (editCalificationChange)="editCalification()"
      />
      @if (qualificationError()) {
        <p class="qualification-error" role="alert">
          {{ 'rating_modal.error' | translate }}
        </p>
      }
    </aside>
  </div>
</section>
